module.exports = __webpack_public_path__ + "img/poster_split.11ea2aa.png";